import ReactGA from 'react-ga';
import Banner from './components/Banner';
import Footer from './components/Footer';
import FooterBottom from './components/FooterBottom';
import Home from './components/Home';
import MigrationModule from './components/MigrationModule';
import SegregationModule from './components/SegregationModule';
import MobilityModule from './components/MobilityModule';
import Login from './components/admin/Login';
import MainEdit from './components/admin/MainEdit';
import MigrationEdit from './components/admin/MigrationEdit';
import MobilityEdit from './components/admin/MobilityEdit';
import SegregationEdit from './components/admin/SegregationEdit';
import FilterFeaturesEdit from './components/admin/FilterFeaturesEdit';
import DerivedFeaturesEdit from './components/admin/DerivedFeaturesEdit';
import SegregationFeaturesEdit from './components/admin/SegregationFeaturesEdit';
import LayersConfiguration from './components/admin/LayersConfiguration';
import ObservatoryPagesAdd from './components/admin/ObservatoryPagesAdd';
import ObservatoryPages from './components/admin/ObservatoryPages';
import Resources from './components/admin/Resources';

import {
  BrowserRouter,
  Routes,
  Route,
  Navigate
} from "react-router-dom";
import Visualizations from './components/Visualizations';
import { useState, useContext, useEffect } from "react";
import { JSONContext } from './Store'
import { store } from './Store';
// import { isLoggedIn } from "./utils/utils";
import { getCurrentUser, refreshToken, logoutUser } from "./services/authService";
import { getMainConfig } from "./components/admin/apiCalls"
import Observatory from './components/observatory/Observatory';
import ChangePassword from './components/admin/ChangePassword';
import useAnalytics from './components/UseAnalytics';
import { jwtDecode } from 'jwt-decode';

function App(props) {

  const TRACKING_ID = window.REACT_APP_GOOGLE_ANALYTICS_KEY || "";

  const WEB_FOLDER = window.REACT_APP_WEB_FOLDER || "";

  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(undefined);

  const [responseJSON, setResponseJSON] = useState([]);
  const [firstResponseJSON, setFirstResponseJSON] = useState({});
  const [textSPC, setTextSPC] = useState('');
  const [formTypeQuery, setFormTypeQuery] = useState('');
  const [selectedDA, setSelectedDA] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const STORAGE_CONFIG = `config/${window.REACT_APP_WEB_FOLDER || ""}`;
  const STORAGE_USER = `user/${window.REACT_APP_WEB_FOLDER || ""}`;

	useEffect(() => {
    // Google Analytics stuff
    ReactGA.initialize(TRACKING_ID);

    getMainConfig((data) => {
      localStorage.setItem(STORAGE_CONFIG, JSON.stringify(data));
    });

    const user = getCurrentUser();

    if (user) {
      setCurrentUser(user);
      setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    };

    if (user && user.accessToken) {
      const decodedToken = JSON.parse(atob(user.accessToken.split(".")[1]));
      const expiresAt = decodedToken.exp * 1000;
      
      // console.log(expiresAt);
      let dateNow = new Date(Date.now());
      let date = new Date(expiresAt);
      // console.log(`NOW: ${dateNow}\nTOKEN: ${date}`);

      if (Date.now() >= expiresAt) {
        refreshToken().then((newAccessToken) => {
          if (!newAccessToken) {
            logoutUser();
            window.location.reload();
          }
        });
      }
    }

	}, []);

  useEffect(() => {
    //window.alert(showAdminBoard);
  }, [showAdminBoard]);

  // Wrapper function to use analytics
  function Analytics() {
    useAnalytics();
    return null; // This component doesn't render anything
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const user = getCurrentUser();

      if (user && user.accessToken) {
        const decodedToken = JSON.parse(atob(user.accessToken.split(".")[1]));
        const expiresAt = decodedToken.exp * 1000;
        
        // console.log(expiresAt);
        let dateNow = new Date(Date.now());
        let date = new Date(expiresAt);
        // console.log(`NOW: ${dateNow}\nTOKEN: ${date}`);

        if (Date.now() >= expiresAt) {
          refreshToken().then((newAccessToken) => {
            if (!newAccessToken) {
              logoutUser();
              window.location.reload();
            }
          });
        }
      }
    }, 60); // check every 15 minutes
    return () => clearInterval(interval);
  }, [currentUser]);

  function isTokenValid(token) {
    try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000; // JS timestamps are in milliseconds

        // Check if the token's expiration time is greater than the current time
        if (decoded.exp && decoded.exp > currentTime) {
            return true; // The token is not expired
        } else {
            return false; // The token is expired
        }
    } catch (error) {
        // If there's an error decoding the token, assume it's invalid
        return false;
    }
  }

  return (
    <>
    <JSONContext.Provider value={{
      responseJSON, setResponseJSON,
      firstResponseJSON, setFirstResponseJSON,
      textSPC, setTextSPC,
      formTypeQuery, setFormTypeQuery,
      selectedDA, setSelectedDA,
      isLoading, setIsLoading,
      formData, setFormData
    }}>
    <BrowserRouter basename={ WEB_FOLDER }>
    <Analytics />
    <body>
        <div className="odisea-page-layout">
          <Banner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/visualizations" element={<Visualizations />} />
              <Route path="/migration" element={<MigrationModule />} />
              <Route path="/segregation" element={<SegregationModule />} />
              <Route path="/mobility" element={<MobilityModule />} />
              <Route path="/observatory" element={<Observatory />} />
              <Route path="/observatory/:pagecode" element={<Observatory />} />
              { (showAdminBoard) ? <Route path="/login" element={<Navigate replace to="/admin/main" /> }/> : <Route path="/login" element={<Login />} />}
              { (showAdminBoard) ? <Route path="/admin" element={<Navigate replace to="/admin/main" /> }/> : <Route path="/admin" element={<Navigate replace to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/main" element={<MainEdit />} /> : <Route path="/admin/main" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/migration" dispatch={props.dispatch} element={<MigrationEdit />} /> : <Route path="/admin/migration" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/mobility" dispatch={props.dispatch} element={<MobilityEdit />} /> : <Route path="/admin/mobility" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/segregation" dispatch={props.dispatch} element={<SegregationEdit />} /> : <Route path="/admin/segregation" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/filter-features" dispatch={props.dispatch} element={<FilterFeaturesEdit />} /> : <Route path="/admin/filter-features" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/derived-features" dispatch={props.dispatch} element={<DerivedFeaturesEdit />} /> : <Route path="/admin/derived-features" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/segregation-features" dispatch={props.dispatch} element={<SegregationFeaturesEdit />} /> : <Route path="/admin/segregation-features" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/layers-configuration" dispatch={props.dispatch} element={<LayersConfiguration />} /> : <Route path="/admin/layers-configuration" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/observatory-pages" dispatch={props.dispatch} element={<ObservatoryPages />} /> : <Route path="/admin/observatory-pages" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/observatory-pages/add" dispatch={props.dispatch} element={<ObservatoryPagesAdd />} /> : <Route path="/admin/observatory-pages" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/observatory-pages/edit/:pagecode" dispatch={props.dispatch} element={<ObservatoryPagesAdd />} /> : <Route path="/admin/observatory-pages" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/resources" dispatch={props.dispatch} element={<Resources />} /> : <Route path="/admin/resources" element={<Navigate to="/login" />} />}
              { (showAdminBoard) ? <Route path="/admin/change-password" dispatch={props.dispatch} element={<ChangePassword />} /> : <Route path="/admin/change-password" element={<Navigate to="/login" />} />}
              {/* <Route path="/*" element={<Navigate to={ WEB_FOLDER } />}  /> navigate to default route if no url matched */}
            </Routes>
            <Footer />
          <FooterBottom />
        </div>
      </body>
      </BrowserRouter>
      </JSONContext.Provider>
    </>      
    
  );
}

export default App;
